import { ClientsService } from "../../clients/services/clientsService";
import type { TreeClientListItem } from "../../clients/types/clients-api.types";

const DEFAULT_LIMIT = 100;

export async function fetchVerifiedClientsTreeSearch(
  search: string | undefined,
  limit: number = DEFAULT_LIMIT
): Promise<TreeClientListItem[]> {
  const trimmed = search?.trim();
  const response = await ClientsService.fetchTree({
    skip: 0,
    limit,
    ...(trimmed ? { search: trimmed } : {}),
  });
  return response.data.data ?? [];
}
